import { ChangeSvgColorPassingBE } from "../CustomSvg";
import { removeFabricObjectsByName, removeFabricObjectsEncId } from "./bringFabricObjects";
import { getBeaconPin, getProductPin, getVerticalPin } from "./getPinIcons";
import { triggerMouseWheelManually } from "./handleMouseWheel";

const updateProductPin = (canvas, selProductDtls, projectSettings, setCanvasUpdated, addNewProduct, combinedArray) => {
    if (canvas?.current && selProductDtls?.enc_id && selProductDtls?.position) {
        if (combinedArray) {
            combinedArray?.forEach((obj) => {
                if (obj.name === "temp_prod") {
                    removeFabricObjectsByName(canvas, "temp_prod");
                    let fillColor =
                        selProductDtls?.product_color ??
                        projectSettings?.product_color ??
                        "red";
                    let productIcon = getProductPin(fillColor)
                    let path = fabric.loadSVGFromString(
                        productIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selProductDtls?.position?.x - obj.width / 2,
                                top: selProductDtls?.position?.y - obj.width / 2,
                                name: "temp_prod",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab", boundaryGroup: true,
                            });

                            canvas?.current?.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selProductDtls?.enc_id && obj?.name === 'product') {
                    removeFabricObjectsEncId(canvas, obj?.enc_id, 'product');
                    let fillColor =
                        selProductDtls?.product_color ?? projectSettings?.product_color;
                    let productIcon = getProductPin(fillColor)
                    let square;
                    square = new fabric.Rect({
                        left: selProductDtls?.position?.x - 14,
                        top: selProductDtls.position?.y - 15,
                        width: 26,
                        height: 28,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });

                    let path = fabric.loadSVGFromString(
                        productIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);
                            obj.set({
                                left: selProductDtls?.position?.x - obj.width / 2,
                                top: selProductDtls.position?.y - obj.height / 2,
                                selectable: false,
                                name: "product",
                                id: selProductDtls.product_name,
                                enc_id: selProductDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            if (addNewProduct) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: addNewProduct ? true : false,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    hoverCursor: "grab", boundaryGroup: true,
                                });
                                // Without this, the group renders at scale 1
                                // (i.e. too big whenever zoom > 1) for one frame
                                // until the trailing triggerMouseWheelManually()
                                // call below corrects it - visible as the pin
                                // flashing oversized then shrinking, especially
                                // now that entering edit mode zooms in to 2.5x.
                                const dragZoom = canvas.current.getZoom();
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selProductDtls?.position?.x, y: selProductDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                canvas.current.add(group).renderAll();
                            } else {
                                let singleLineProductName = (selProductDtls.product_name || '').replace(/\s/g, " ");
                                let textObj = new fabric.Textbox(singleLineProductName, {
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls.position?.y - 24,
                                    fill: "#515151",
                                    fontSize: 12,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    selectable: false,
                                    originX: "center",
                                    originY: "center",
                                    fontFamily: `'SF Pro Text',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`
                                });
                                let backgroundRect = new fabric.Rect({
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls.position?.y - 24,
                                    width: textObj.width + 12,
                                    height: textObj.height + 5,
                                    fill: "#ffffffad",
                                    strokeWidth: 1,
                                    originX: "center",
                                    originY: "center",
                                    selectable: false,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    rx: 2,
                                    ry: 2,
                                });
                                const labelGroup = new fabric.Group([backgroundRect, textObj, obj], {
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    selectable: false,
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls?.position?.y,
                                    originX: 'center',
                                    originY: 'center',
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                });
                                const productZoom = canvas.current.getZoom();
                                if (!(productZoom < 1)) {
                                    labelGroup.scaleX = labelGroup.scaleX / productZoom;
                                    labelGroup.scaleY = labelGroup.scaleY / productZoom;
                                }
                                canvas.current.add(labelGroup).renderAll();
                            }

                        }
                    );
                }
            });
        } else {
            canvas?.current?.forEachObject((obj) => {
                if (obj.name === "temp_prod") {
                    removeFabricObjectsByName(canvas, "temp_prod");
                    let fillColor =
                        selProductDtls?.product_color ??
                        projectSettings?.product_color ??
                        "red";
                    let productIcon = getProductPin(fillColor)
                    let path = fabric.loadSVGFromString(
                        productIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selProductDtls?.position?.x - obj.width / 2,
                                top: selProductDtls?.position?.y - obj.width / 2,
                                name: "temp_prod",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });

                            canvas?.current?.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selProductDtls?.enc_id && obj?.name === 'product') {
                    removeFabricObjectsEncId(canvas, obj?.enc_id, 'product');
                    let fillColor =
                        selProductDtls?.product_color ?? projectSettings?.product_color;
                    let productIcon = getProductPin(fillColor)
                    let square;
                    square = new fabric.Rect({
                        left: selProductDtls?.position?.x - 14,
                        top: selProductDtls.position?.y - 15,
                        width: 26,
                        height: 28,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });

                    let path = fabric.loadSVGFromString(
                        productIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);
                            obj.set({
                                left: selProductDtls?.position?.x - obj.width / 2,
                                top: selProductDtls.position?.y - obj.height / 2,
                                selectable: false,
                                name: "product",
                                id: selProductDtls.product_name,
                                enc_id: selProductDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            if (addNewProduct) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: addNewProduct ? true : false,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    hoverCursor: "grab", boundaryGroup: true,
                                });
                                // Without this, the group renders at scale 1
                                // (i.e. too big whenever zoom > 1) for one frame
                                // until the trailing triggerMouseWheelManually()
                                // call below corrects it - visible as the pin
                                // flashing oversized then shrinking, especially
                                // now that entering edit mode zooms in to 2.5x.
                                const dragZoom = canvas.current.getZoom();
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selProductDtls?.position?.x, y: selProductDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                canvas.current.add(group).renderAll();
                            } else {
                                let singleLineProductName = (selProductDtls.product_name || '').replace(/\s/g, " ");
                                let textObj = new fabric.Textbox(singleLineProductName, {
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls.position?.y - 24,
                                    fill: "#515151",
                                    fontSize: 12,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    selectable: false,
                                    originX: "center",
                                    originY: "center",
                                    fontFamily: `'SF Pro Text',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`
                                });
                                let backgroundRect = new fabric.Rect({
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls.position?.y - 24,
                                    width: textObj.width + 12,
                                    height: textObj.height + 5,
                                    fill: "#ffffffad",
                                    strokeWidth: 1,
                                    originX: "center",
                                    originY: "center",
                                    selectable: false,
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    rx: 2,
                                    ry: 2,
                                });
                                const labelGroup = new fabric.Group([backgroundRect, textObj, obj], {
                                    name: "product",
                                    id: selProductDtls.enc_id,
                                    enc_id: selProductDtls?.enc_id,
                                    selectable: false,
                                    left: selProductDtls?.position?.x,
                                    top: selProductDtls?.position?.y,
                                    originX: 'center',
                                    originY: 'center',
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                });
                                const productZoom = canvas.current.getZoom();
                                if (!(productZoom < 1)) {
                                    labelGroup.scaleX = labelGroup.scaleX / productZoom;
                                    labelGroup.scaleY = labelGroup.scaleY / productZoom;
                                }
                                canvas.current.add(labelGroup).renderAll();
                            }

                        }
                    );
                }
            });
        }

        window.requestAnimationFrame(() => {
            canvas?.current?.renderAll();
            setCanvasUpdated((prev) => !prev);
        });
        // canvas?.current?.renderAll();
        triggerMouseWheelManually(canvas)
    }
}

const updateBeaconPin = (canvas, selBeaconDtls, projectSettings, setCanvasUpdated, combinedArray, addNewQrCodeBeacon) => {
    if (canvas?.current && selBeaconDtls?.enc_id && selBeaconDtls?.position) {
        if (combinedArray) {
            combinedArray?.forEach((obj) => {
                if (obj.name === "temp_beacon") {
                    removeFabricObjectsByName(canvas, "temp_beacon");
                    let fillColor =
                        selBeaconDtls?.beacon_color ??
                        projectSettings?.beacon_color ??
                        "red";
                    let beaconIcon = getBeaconPin(fillColor)
                    let path = fabric.loadSVGFromString(
                        beaconIcon,
                        function (objects, options) {
                            let objUpdate = fabric.util.groupSVGElements(objects, options);
                            objUpdate.set({
                                left: selBeaconDtls?.position?.x - obj.width / 2,
                                top: selBeaconDtls?.position?.y - obj.width / 2,
                                name: "temp_beacon",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas?.current?.add(objUpdate);
                        }
                    );
                } else if (obj?.enc_id == selBeaconDtls?.enc_id && obj?.name === 'beacon') {
                    removeFabricObjectsEncId(canvas, obj?.enc_id, 'beacon');
                    let fillColor =
                        selBeaconDtls?.beacon_color ??
                        projectSettings?.beacon_color ??
                        "red";
                    let beaconIcon = getBeaconPin(fillColor)
                    let square;
                    square = new fabric.Rect({
                        left: selBeaconDtls.position?.x - 12,
                        top: selBeaconDtls.position?.y - 12,
                        width: 22,
                        height: 22,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2
                    });

                    let path = fabric.loadSVGFromString(
                        beaconIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                // left: prod.position?.x - obj.width / 2,
                                // top: prod.position?.y - obj.height / 2,
                                left: selBeaconDtls?.position?.x - obj.width / 2,
                                top: selBeaconDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "beacon",
                                id: selBeaconDtls.beacon_name,
                                enc_id: selBeaconDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            if (addNewQrCodeBeacon) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: true,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    hoverCursor: "grab",
                                    hasBorders: false,
                                    hasControls: false,
                                });
                                // See updateProductPin for why this correction is
                                // needed here (prevents an oversized flash while
                                // dragging the pin at zoom > 1).
                                const dragZoom = canvas.current.getZoom();
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selBeaconDtls?.position?.x, y: selBeaconDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                canvas.current.add(group).renderAll();
                            } else {
                                let singleLineBeaconName = (selBeaconDtls.beacon_name || '').replace(/\s/g, " ");
                                let textObj = new fabric.Textbox(singleLineBeaconName, {
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls.position?.y - 21,
                                    fill: "#515151",
                                    fontSize: 12,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    selectable: false,
                                    originX: "center",
                                    originY: "center",
                                    fontFamily: `'SF Pro Text',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`
                                });
                                let backgroundRect = new fabric.Rect({
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls.position?.y - 21,
                                    width: textObj.width + 12,
                                    height: textObj.height + 5,
                                    fill: "#ffffffad",
                                    strokeWidth: 1,
                                    originX: "center",
                                    originY: "center",
                                    selectable: false,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    rx: 2,
                                    ry: 2,
                                });
                                const labelGroup = new fabric.Group([backgroundRect, textObj, obj], {
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    selectable: false,
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls?.position?.y,
                                    originX: 'center',
                                    originY: 'center',
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                });
                                const beaconZoom = canvas.current.getZoom();
                                if (!(beaconZoom < 1)) {
                                    labelGroup.scaleX = labelGroup.scaleX / beaconZoom;
                                    labelGroup.scaleY = labelGroup.scaleY / beaconZoom;
                                }
                                canvas.current.add(labelGroup).renderAll();
                            }
                        }
                    );
                }
            });
        } else {
            canvas?.current?.forEachObject((obj) => {
                if (obj.name === "temp_beacon") {
                    removeFabricObjectsByName(canvas, "temp_beacon");
                    let fillColor =
                        selBeaconDtls?.beacon_color ??
                        projectSettings?.beacon_color ??
                        "red";
                    let beaconIcon = getBeaconPin(fillColor)
                    let path = fabric.loadSVGFromString(
                        beaconIcon,
                        function (objects, options) {
                            let objUpdate = fabric.util.groupSVGElements(objects, options);
                            objUpdate.set({
                                left: selBeaconDtls?.position?.x - obj.width / 2,
                                top: selBeaconDtls?.position?.y - obj.width / 2,
                                name: "temp_beacon",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas?.current?.add(objUpdate);
                        }
                    );
                } else if (obj?.enc_id == selBeaconDtls?.enc_id && obj?.name === 'beacon') {
                    removeFabricObjectsEncId(canvas, obj?.enc_id, 'beacon');
                    let fillColor =
                        selBeaconDtls?.beacon_color ??
                        projectSettings?.beacon_color ??
                        "red";
                    let beaconIcon = getBeaconPin(fillColor)
                    let square;
                    square = new fabric.Rect({
                        left: selBeaconDtls.position?.x - 12,
                        top: selBeaconDtls.position?.y - 12,
                        width: 22,
                        height: 22,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2
                    });

                    let path = fabric.loadSVGFromString(
                        beaconIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                // left: prod.position?.x - obj.width / 2,
                                // top: prod.position?.y - obj.height / 2,
                                left: selBeaconDtls?.position?.x - obj.width / 2,
                                top: selBeaconDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "beacon",
                                id: selBeaconDtls.beacon_name,
                                enc_id: selBeaconDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            if (addNewQrCodeBeacon) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: true,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    hoverCursor: "grab"
                                });
                                // See updateProductPin for why this correction is
                                // needed here (prevents an oversized flash while
                                // dragging the pin at zoom > 1).
                                const dragZoom = canvas.current.getZoom();
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selBeaconDtls?.position?.x, y: selBeaconDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                canvas.current.add(group).renderAll();
                            } else {
                                let singleLineBeaconName = (selBeaconDtls.beacon_name || '').replace(/\s/g, " ");
                                let textObj = new fabric.Textbox(singleLineBeaconName, {
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls.position?.y - 21,
                                    fill: "#515151",
                                    fontSize: 12,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    selectable: false,
                                    originX: "center",
                                    originY: "center",
                                    fontFamily: `'SF Pro Text',-apple-system,BlinkMacSystemFont,Roboto,'Segoe UI',Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol'`
                                });
                                let backgroundRect = new fabric.Rect({
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls.position?.y - 21,
                                    width: textObj.width + 12,
                                    height: textObj.height + 5,
                                    fill: "#ffffffad",
                                    strokeWidth: 1,
                                    originX: "center",
                                    originY: "center",
                                    selectable: false,
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    rx: 2,
                                    ry: 2,
                                });
                                const labelGroup = new fabric.Group([backgroundRect, textObj, obj], {
                                    name: "beacon",
                                    id: selBeaconDtls.enc_id,
                                    enc_id: selBeaconDtls?.enc_id,
                                    selectable: false,
                                    left: selBeaconDtls?.position?.x,
                                    top: selBeaconDtls?.position?.y,
                                    originX: 'center',
                                    originY: 'center',
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    hasControls: false,
                                    hasBorders: false,
                                });
                                const beaconZoom = canvas.current.getZoom();
                                if (!(beaconZoom < 1)) {
                                    labelGroup.scaleX = labelGroup.scaleX / beaconZoom;
                                    labelGroup.scaleY = labelGroup.scaleY / beaconZoom;
                                }
                                canvas.current.add(labelGroup).renderAll();
                            }
                        }
                    );
                }
            });
        }
        window.requestAnimationFrame(() => {
            canvas?.current?.renderAll();
            setCanvasUpdated((prev) => !prev);
        });
        triggerMouseWheelManually(canvas)
    }
}

const updateAmenityPin = (canvas, selAmenityDtls, projectSettings, setCanvasUpdated, aminityIcons, combinedArray,addNewAmenity) => {
    if (
        canvas?.current &&
        selAmenityDtls?.enc_id &&
        selAmenityDtls?.position
    ) {
        if (combinedArray) {
            combinedArray?.forEach((obj) => {
                if (obj.name === "temp_amenity") {
                    //// console.log(selAmenityDtls);
                    removeFabricObjectsByName(canvas, "temp_amenity");
                    let fillColor =
                        selAmenityDtls?.amenity_color ??
                        projectSettings?.amenity_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the aminityIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped amenity has no matching icon_id) and silently produces
                    // an unparseable SVG, which Fabric then fails to render at all.
                    let iconPath = selAmenityDtls?.path ?? aminityIcons.find(
                        (ele) => selAmenityDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let amenityIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let path = fabric.loadSVGFromString(
                        amenityIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selAmenityDtls?.position?.x - obj.width / 2,
                                top: selAmenityDtls?.position?.y - obj.width / 2,
                                name: "temp_amenity",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas.current.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selAmenityDtls?.enc_id && obj?.name === 'amenity') {
                    removeFabricObjectsEncId(canvas, selAmenityDtls?.enc_id, 'amenity');
                    let fillColor =
                        selAmenityDtls?.amenity_color ??
                        projectSettings?.amenity_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the aminityIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped amenity has no matching icon_id) and silently produces
                    // an unparseable SVG, which Fabric then fails to render at all.
                    let iconPath = selAmenityDtls?.path ?? aminityIcons.find(
                        (ele) => selAmenityDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let amenityIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let square;
                    square = new fabric.Rect({
                        left: selAmenityDtls.position?.x - 13,
                        top: selAmenityDtls.position?.y - 13,
                        width: 24,
                        height: 24,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });

                    let path = fabric.loadSVGFromString(
                        amenityIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selAmenityDtls.position?.x - obj.width / 2,
                                top: selAmenityDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "amenity",
                                id: selAmenityDtls.amenity_name,
                                enc_id: selAmenityDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            const dragZoom = canvas.current.getZoom();
                            if (addNewAmenity) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: true,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    name: "amenity",
                                    id: selAmenityDtls.enc_id,
                                    enc_id: selAmenityDtls?.enc_id,
                                    hoverCursor: "grab",
                                    hasBorders: false,
                                    hasControls: false,
                                });
                                // See updateProductPin for why this correction is
                                // needed here (prevents an oversized flash while
                                // dragging the pin at zoom > 1).
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selAmenityDtls?.position?.x, y: selAmenityDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                canvas.current.add(group).renderAll();
                            } else {
                                if (!(dragZoom < 1)) {
                                    obj.scaleX = obj.scaleX / dragZoom;
                                    obj.scaleY = obj.scaleY / dragZoom;
                                    obj.setPositionByOrigin(
                                        { x: selAmenityDtls?.position?.x, y: selAmenityDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    obj.setCoords();
                                }
                                canvas.current.add(obj).renderAll();
                            }
                        }
                    );
                }
            });
        } else {
            canvas?.current?.forEachObject((obj) => {
                if (obj.name === "temp_amenity") {
                    //// console.log(selAmenityDtls);
                    removeFabricObjectsByName(canvas, "temp_amenity");
                    let fillColor =
                        selAmenityDtls?.amenity_color ??
                        projectSettings?.amenity_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the aminityIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped amenity has no matching icon_id) and silently produces
                    // an unparseable SVG, which Fabric then fails to render at all.
                    let iconPath = selAmenityDtls?.path ?? aminityIcons.find(
                        (ele) => selAmenityDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let amenityIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let path = fabric.loadSVGFromString(
                        amenityIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selAmenityDtls?.position?.x - obj.width / 2,
                                top: selAmenityDtls?.position?.y - obj.width / 2,
                                name: "temp_amenity",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas.current.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selAmenityDtls?.enc_id && obj?.name === 'amenity') {
                    removeFabricObjectsEncId(canvas, selAmenityDtls?.enc_id, 'amenity');
                    let fillColor =
                        selAmenityDtls?.amenity_color ??
                        projectSettings?.amenity_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the aminityIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped amenity has no matching icon_id) and silently produces
                    // an unparseable SVG, which Fabric then fails to render at all.
                    let iconPath = selAmenityDtls?.path ?? aminityIcons.find(
                        (ele) => selAmenityDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let amenityIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let square;
                    square = new fabric.Rect({
                        left: selAmenityDtls.position?.x - 13,
                        top: selAmenityDtls.position?.y - 13,
                        width: 24,
                        height: 24,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });

                    let path = fabric.loadSVGFromString(
                        amenityIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selAmenityDtls.position?.x - obj.width / 2,
                                top: selAmenityDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "amenity",
                                id: selAmenityDtls.amenity_name,
                                enc_id: selAmenityDtls?.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            const group = new fabric.Group([square, obj], {
                                selectable: true,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                name: "amenity",
                                id: selAmenityDtls.enc_id,
                                enc_id: selAmenityDtls?.enc_id,
                                hoverCursor: "grab"
                            });
                            // See updateProductPin for why this correction is
                            // needed here (prevents an oversized flash while
                            // dragging the pin at zoom > 1).
                            const dragZoom = canvas.current.getZoom();
                            if (!(dragZoom < 1)) {
                                group.scaleX = group.scaleX / dragZoom;
                                group.scaleY = group.scaleY / dragZoom;
                                group.setPositionByOrigin(
                                    { x: selAmenityDtls?.position?.x, y: selAmenityDtls?.position?.y },
                                    'center',
                                    'center'
                                );
                                group.setCoords();
                            }
                            canvas.current.add(group).renderAll();
                        }
                    );
                }
            });
        }
        window.requestAnimationFrame(() => {
            canvas?.current?.renderAll();
            setCanvasUpdated((prev) => !prev);
        });
        triggerMouseWheelManually(canvas)
    }
}

const updateSafetyPin = (canvas, selSafetyDtls, projectSettings, setCanvasUpdated, safetyIcons, combinedArray,addNewSafety) => {
    if (canvas?.current && selSafetyDtls?.enc_id && selSafetyDtls?.position
    ) {
        if (combinedArray) {
            combinedArray?.forEach((obj) => {
                if (obj.name === "temp_safety") {
                    removeFabricObjectsByName(canvas, "temp_safety");
                    let fillColor =
                        selSafetyDtls?.safety_color ??
                        projectSettings?.safety_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the safetyIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped safety pin has no matching icon_id) and silently
                    // produces an unparseable SVG, which Fabric then fails to
                    // render at all.
                    let iconPath = selSafetyDtls?.path ?? safetyIcons.find(
                        (ele) => selSafetyDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let safetyIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let path = fabric.loadSVGFromString(
                        safetyIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selSafetyDtls?.position?.x - obj.width / 2,
                                top: selSafetyDtls?.position?.y - obj.width / 2,
                                name: "temp_safety",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas.current.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selSafetyDtls?.enc_id && obj?.name === 'safety') {
                    removeFabricObjectsEncId(canvas, selSafetyDtls?.enc_id, 'safety');
                    let fillColor =
                        selSafetyDtls?.safety_color ??
                        projectSettings?.safety_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the safetyIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped safety pin has no matching icon_id) and silently
                    // produces an unparseable SVG, which Fabric then fails to
                    // render at all.
                    let iconPath = selSafetyDtls?.path ?? safetyIcons.find(
                        (ele) => selSafetyDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let safetyIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let square;

                    square = new fabric.Rect({
                        left: selSafetyDtls.position?.x - 13,
                        top: selSafetyDtls.position?.y - 13,
                        width: 24,
                        height: 24,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });
                    let path = fabric.loadSVGFromString(
                        safetyIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selSafetyDtls.position?.x - obj.width / 2,
                                top: selSafetyDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "safety",
                                id: selSafetyDtls.safety_name,
                                enc_id: selSafetyDtls.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });
                            const dragZoom = canvas.current.getZoom();
                            if (addNewSafety) {
                                const group = new fabric.Group([square, obj], {
                                    selectable: true,
                                    lockRotation: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    name: "safety",
                                    id: selSafetyDtls.enc_id,
                                    enc_id: selSafetyDtls?.enc_id,
                                    hoverCursor: "grab"
                                });
                                // See updateProductPin for why this correction is
                                // needed here (prevents an oversized flash while
                                // dragging the pin at zoom > 1).
                                if (!(dragZoom < 1)) {
                                    group.scaleX = group.scaleX / dragZoom;
                                    group.scaleY = group.scaleY / dragZoom;
                                    group.setPositionByOrigin(
                                        { x: selSafetyDtls?.position?.x, y: selSafetyDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    group.setCoords();
                                }
                                // Highlight the edited pin
                                canvas.current.add(group).renderAll();
                            } else {
                                if (!(dragZoom < 1)) {
                                    obj.scaleX = obj.scaleX / dragZoom;
                                    obj.scaleY = obj.scaleY / dragZoom;
                                    obj.setPositionByOrigin(
                                        { x: selSafetyDtls?.position?.x, y: selSafetyDtls?.position?.y },
                                        'center',
                                        'center'
                                    );
                                    obj.setCoords();
                                }
                                canvas.current.add(obj).renderAll();
                            }
                        }
                    );
                }
            });
        } else {
            canvas?.current?.forEachObject((obj) => {
                if (obj.name === "temp_safety") {
                    removeFabricObjectsByName(canvas, "temp_safety");
                    let fillColor =
                        selSafetyDtls?.safety_color ??
                        projectSettings?.safety_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the safetyIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped safety pin has no matching icon_id) and silently
                    // produces an unparseable SVG, which Fabric then fails to
                    // render at all.
                    let iconPath = selSafetyDtls?.path ?? safetyIcons.find(
                        (ele) => selSafetyDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let safetyIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let path = fabric.loadSVGFromString(
                        safetyIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selSafetyDtls?.position?.x - obj.width / 2,
                                top: selSafetyDtls?.position?.y - obj.width / 2,
                                name: "temp_safety",
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab",
                                boundaryGroup: true,
                            });
                            canvas.current.add(obj);
                        }
                    );
                } else if (obj?.enc_id == selSafetyDtls?.enc_id && obj?.name === 'safety') {
                    removeFabricObjectsEncId(canvas, selSafetyDtls?.enc_id, 'safety');
                    let fillColor =
                        selSafetyDtls?.safety_color ??
                        projectSettings?.safety_color ??
                        "red";
                    // Prefer the already-resolved icon SVG (same field renderObjs.js
                    // and the drop handler use) - the safetyIcons list lookup by
                    // icon_id is fragile (list may not be loaded yet, or a freshly
                    // dropped safety pin has no matching icon_id) and silently
                    // produces an unparseable SVG, which Fabric then fails to
                    // render at all.
                    let iconPath = selSafetyDtls?.path ?? safetyIcons.find(
                        (ele) => selSafetyDtls?.icon_id == ele?.enc_id
                    )?.path;
                    let safetyIcon = ChangeSvgColorPassingBE(iconPath, fillColor);
                    let square;

                    square = new fabric.Rect({
                        left: selSafetyDtls.position?.x - 13,
                        top: selSafetyDtls.position?.y - 13,
                        width: 24,
                        height: 24,
                        fill: "transparent",
                        stroke: "red",
                        strokeWidth: 2,
                        hoverCursor: "grab"
                    });
                    let path = fabric.loadSVGFromString(
                        safetyIcon,
                        function (objects, options) {
                            let obj = fabric.util.groupSVGElements(objects, options);

                            obj.set({
                                left: selSafetyDtls.position?.x - obj.width / 2,
                                top: selSafetyDtls.position?.y - obj.height / 2,
                                selectable: true,
                                name: "safety",
                                id: selSafetyDtls.safety_name,
                                enc_id: selSafetyDtls.enc_id,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                hoverCursor: "grab"
                            });

                            const group = new fabric.Group([square, obj], {
                                selectable: true,
                                lockRotation: true,
                                lockScalingX: true,
                                lockScalingY: true,
                                name: "safety",
                                id: selSafetyDtls.enc_id,
                                enc_id: selSafetyDtls?.enc_id,
                                hoverCursor: "grab",
                                hasBorders: false,
                                hasControls: false,
                            });
                            // See updateProductPin for why this correction is
                            // needed here (prevents an oversized flash while
                            // dragging the pin at zoom > 1).
                            const dragZoom = canvas.current.getZoom();
                            if (!(dragZoom < 1)) {
                                group.scaleX = group.scaleX / dragZoom;
                                group.scaleY = group.scaleY / dragZoom;
                                group.setPositionByOrigin(
                                    { x: selSafetyDtls?.position?.x, y: selSafetyDtls?.position?.y },
                                    'center',
                                    'center'
                                );
                                group.setCoords();
                            }
                            // Highlight the edited pin
                            canvas.current.add(group).renderAll();
                        }
                    );
                }
            });
        }
        window.requestAnimationFrame(() => {
            canvas?.current?.renderAll();
            setCanvasUpdated((prev) => !prev);
        });
        triggerMouseWheelManually(canvas)
    }
}

const updateVerticalPin = (canvas, selVerticalDtls, projectSettings, combinedArray) => {

    if (
        canvas?.current &&
        (selVerticalDtls?.vt_color || selVerticalDtls?.icon_path)
    ) {
        // if (combinedArray) {
        canvas?.current?.forEachObject((obj) => {
            if (obj.name === "temp_vertical") {
                removeFabricObjectsByName(canvas, "temp_vertical");
                let fillColor =
                    selVerticalDtls?.vt_color ??
                    projectSettings?.level_change_color ??
                    "red";
                let safetyIcon = selVerticalDtls?.icon_path
                    ? ChangeSvgColorPassingBE(selVerticalDtls?.icon_path, fillColor)
                    : getVerticalPin(fillColor)
                let path = fabric.loadSVGFromString(
                    safetyIcon,
                    function (objects, options) {
                        let obj = fabric.util.groupSVGElements(objects, options);

                        obj.set({
                            left: selVerticalDtls?.position?.x - obj.width / 2,
                            top: selVerticalDtls?.position?.y - obj.width / 2,
                            name: "temp_vertical",
                            lockRotation: true,
                            lockScalingX: true,
                            lockScalingY: true,
                            hoverCursor: "grab",
                            boundaryGroup: true,
                        });
                        canvas.current.add(obj);
                    }
                );
            }
        });
        //     } else {
        //         canvas?.current?.forEachObject((obj) => {
        //             if (obj.name === "temp_vertical") {
        // // console.log(obj,"at update pin")

        //                 removeFabricObjectsByName(canvas, "temp_vertical");
        //                 let fillColor =
        //                     selVerticalDtls?.vt_color ??
        //                     projectSettings?.level_change_color ??
        //                     "red";
        //                 let safetyIcon = selVerticalDtls?.icon_path
        //                     ? ChangeSvgColorPassingBE(selVerticalDtls?.icon_path, fillColor)
        //                     : getVerticalPin(fillColor)
        //                 let path = fabric.loadSVGFromString(
        //                     safetyIcon,
        //                     function (objects, options) {
        //                         let obj = fabric.util.groupSVGElements(objects, options);

        //                         obj.set({
        //                             left: selVerticalDtls?.position?.x - obj.width / 2,
        //                             top: selVerticalDtls?.position?.y - obj.width / 2,
        //                             name: "temp_vertical",
        //                             lockRotation: true,
        //                             lockScalingX: true,
        //                             lockScalingY: true,
        //                             hoverCursor: "grab",
        //                             boundaryGroup:true,
        //                         });
        //                         canvas.current.add(obj);
        //                     }
        //                 );
        //             }
        //         });
        //     }
        canvas?.current?.renderAll();
        triggerMouseWheelManually(canvas)
    }
}

export {
    updateProductPin,
    updateBeaconPin,
    updateAmenityPin,
    updateSafetyPin,
    updateVerticalPin
}